import React, { useState, } from "react";
import {
  Form,
  Dimmer,
  Loader,
  Button,
  Message,
  Icon
} from "semantic-ui-react";


// ----------------------------------------------------
// Only used by Register - the account app no longer collects first/last
// name anywhere, and Profile has its own standalone form.
const UserForm = (props) => {
  const [checkInputMessages, setCheckInputMessages] = useState([]);
  const [screenName, setScreenName] = useState("");
  const [registrationCode, setRegistrationCode] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [screenNameError, setScreenNameError] = useState(false);
  const [registrationCodeError, setRegistrationCodeError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [changed, setChanged] = useState(false);
  const requestMessage = props.requestMessage;

  const checkInputs = () => {
    let error = false;
    let inputMessages = [];

    if (registrationCode === "") {
      setRegistrationCodeError(true);
      inputMessages.push("Registration code is required");
      error = true;
    } else {
      setRegistrationCodeError(false);
    }

    if (screenName === "") {
      setScreenNameError(true);
      inputMessages.push("Screen Name is required");
      error = true;
    } else {
      setScreenNameError(false);
    }

    if (password === "") {
      setPasswordError(true);
      inputMessages.push("Password is required");
      error = true;
    } else {
      setPasswordError(false);
    }

    if (password !== confirmPassword) {
      setConfirmPasswordError(true);
      inputMessages.push("The passwords did not match");
      error = true;
    } else {
      setConfirmPasswordError(false);
    }

    setCheckInputMessages(inputMessages);
    return error;
  }


  const handleSubmit = (event) => {
    event.preventDefault();
    let inputError = checkInputs();

    if (!inputError) {
      const user = { screenName, registrationCode, password };
      setChanged(false);
      props.onSubmit(user);
    }
  }


  var floatStyle = {
    overflow: 'auto'
  }
  var dimmerProps = {};
  if (props.isWaiting) {
    dimmerProps["active"] = true;
  }

  var registerMessage = "";
  if (checkInputMessages.length || requestMessage.length) {
    var counter = 0;
    registerMessage = (
      <Message compact warning icon>
        <Icon name="lightning" />
        <Message.Content>
          <Message.Header>Problems...</Message.Header>
          <ul>
            {checkInputMessages.map(function (listValue) {
              return <li key={`ListItem_${counter++}`}>{listValue}</li>;
            })}
            {requestMessage.length > 0 &&
              <li key="req-mess">{requestMessage}</li>
            }
          </ul>
        </Message.Content>
      </Message>
    );
  }

  return (
    <div>
      <Form
        className="raised padding segment"
        onSubmit={handleSubmit}
      >
        <Dimmer {...dimmerProps}>
          <Loader indeterminate>Updating Profile</Loader>
        </Dimmer>

        <Form.Group widths="equal">
          <Form.Field>
            <Form.Input
              type="text"
              name="registrationCode"
              onChange={e => {setRegistrationCode(e.target.value); setChanged(true)}}
              error={registrationCodeError}
              value={registrationCode}
              label="Registration Code"
              placeholder="Registration Code..."
            />
          </Form.Field>
          <Form.Field>
            <Form.Input
              type="text"
              name="screenName"
              onChange={e => {setScreenName(e.target.value); setChanged(true)}}
              error={screenNameError}
              value={screenName}
              label="Username"
              placeholder="Username..."
            />
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field>
            <Form.Input
              name="password"
              type="password"
              onChange={e => {setPassword(e.target.value); setChanged(true)}}
              value={password}
              error={passwordError}
              label="Password"
              placeholder="Password..."
            />
          </Form.Field>
          <Form.Field>
            <Form.Input
              name="confirmPassword"
              type="password"
              onChange={e => {setConfirmPassword(e.target.value); setChanged(true)}}
              value={confirmPassword}
              error={confirmPasswordError}
              label="Confirm Password"
              placeholder="Confirm Password..."
            />
          </Form.Field>
        </Form.Group>
        <div style={floatStyle}>
          <Button type="submit" size="large" floated="right" value="Login" color='blue' disabled={!changed}>
            Register
          </Button>
        </div>
      </Form>
      {registerMessage}
    </div>
  );
}


export default UserForm;
